import {
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    Pagination,
} from "@mui/material"
import { useSessionsContext } from "layouts/sessions/context/sessions-context"
import { sessionsColumns, columnsOrder } from "layouts/sessions/utils/const"
import { SessionHeaderCell } from "layouts/sessions/table/cells"
import {
    StyledTable,
    StyledTableCell,
    StyledTableRow,
} from "components/tables/StyledTable"

export const SessionsTable = () => {
    const { currentSessionsRows, pageNumber, numberOfPages, handleChangePage } =
        useSessionsContext()

    return (
        <>
            <TableContainer sx={{ borderRadius: "10px 10px 0 0" }}>
                <StyledTable aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {columnsOrder.map((col) => {
                                return (
                                    <SessionHeaderCell
                                        key={col}
                                        keySession={col}
                                        title={sessionsColumns[col].title}
                                        width={sessionsColumns[col].width}
                                    />
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {currentSessionsRows.map((session) => (
                            <StyledTableRow key={session.id}>
                                {columnsOrder.map((col) => {
                                    const CellComponent =
                                        sessionsColumns[col].cellComponent
                                    return (
                                        <StyledTableCell key={col}>
                                            <CellComponent session={session} />
                                        </StyledTableCell>
                                    )
                                })}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </TableContainer>

            <Pagination
                color="primary"
                count={numberOfPages}
                page={pageNumber}
                onChange={handleChangePage}
                sx={{
                    mx: "auto",
                }}
            />
        </>
    )
}
